import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/version/index.js
// module id = 1038
// module chunks = 1